import { useState, useEffect } from 'react';
import { TrendingUp } from 'lucide-react';
import Layout from '@/components/layout/Layout';
import ProductGrid from '@/components/products/ProductGrid';
import { productsAPI } from '@/lib/api';

export const Virals = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await productsAPI.getAll({ is_viral: true, limit: 50 });
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return (
    <Layout>
      {/* Header */}
      <section className="bg-gradient-to-br from-[#0F172A] to-[#1E293B] py-12 md:py-16">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-[#FF5722]/20 rounded-lg">
              <TrendingUp className="w-6 h-6 text-[#FF5722]" />
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-white">
              Produtos Virais
            </h1>
          </div>
          <p className="text-slate-300 text-lg max-w-2xl">
            Os produtos mais populares e comentados da internet. Descubra o que está bombando!
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12 md:py-16 bg-slate-50">
        <div className="container mx-auto px-4 max-w-7xl">
          <ProductGrid products={products} loading={loading} />
        </div>
      </section>
    </Layout>
  );
};

export default Virals;
